<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" />
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_COMMUNITY',
        formComponent: {
          add: { type: 'component', componentName: 'Community-edit', value: 'resetCommunityDetailData' },
          edit: { type: 'component', componentName: 'Community-edit', value: 'queryCommunityDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/community/communityList' },
          delete: { type: 'default', value: '/modules/community/communityDelete' }
        },
        formInputsData: [
          { name: '搜索省市县', key: 'areaId', value: '', type: 'select', data: [] },
          { name: '社区', key: 'name', value: '', type: 'text' },
          { name: '创建时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADD' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '区域', key: 'areaName', type: 'text' },
          { name: '社区', key: 'name', type: 'text' },
          { name: '总户数', key: 'house', type: 'text' },
          { name: '创建时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '创建人', key: 'createUserName', type: 'text' }],
        formTableButtonsData: [{ name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false, permission: 'DELETE' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true }
      }
    }
  },
  created() {
    this.requestArea()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log('data', data)
      if (data && data.item) {
        if (data.item.action === 'EDIT') {
          this.$store.dispatch('setCommunityDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    },
    requestArea() {
      request({
        url: '/modules/addressArea/addressAreaList',
        method: 'post'
      }).then(res => {
        if (res.code === '0') {
          for (const item of res.data) {
            item.label = item.name
            item.value = item.id
          }
          res.data.unshift({ id: '', name: '全部', label: '全部' })
          this.form.formInputsData[0].data = res.data
        }
      })
    }
  }
}
</script>
